import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import BlogsSectionBlogWhitePattern3 from '../components/blog-white-pattern/BlogsSectionBlogWhitePattern3';

const meta = {
  title: 'Blog | Bagga International',
  meta: [
    { name: 'description', content: 'Read the latest articles, tips, and updates from Bagga International.' },
    { property: 'og:title', content: 'Blog | Bagga International' },
    { property: 'og:description', content: 'Read the latest articles, tips, and updates from Bagga International.' },
    { property: 'og:image', content: '/images/site-default-og.jpg' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://baggainternational.com/blog' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'Blog | Bagga International' },
    { name: 'twitter:description', content: 'Read the latest articles, tips, and updates from Bagga International.' },
    { name: 'twitter:image', content: '/images/site-default-og.jpg' }
  ],
  link: [
    { rel: 'canonical', href: 'https://baggainternational.com/blog' }
  ],
  style: [],
  script: [],
};

export default function Blogs() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <BlogsSectionBlogWhitePattern3 />
    </React.Fragment>
  );
}

